import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="relative flex flex-col items-center justify-center h-screen text-center px-4">
      <h1 className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-background-200 select-none pointer-events-none z-0">
        404
      </h1>
      <div className="relative z-10">
        <h1 className="text-xl md:text-2xl font-heading text-foreground-900 mt-6">页面未找到</h1>
        <p className="mt-2 text-base text-foreground-400">抱歉，您访问的页面不存在</p>
        <Link
          to="/"
          className="inline-block mt-6 px-6 py-2.5 bg-primary-500 text-background-50 rounded-full text-sm font-medium hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap"
        >
          返回首页
        </Link>
      </div>
    </div>
  );
}